import { render, staticRenderFns } from "./emailTemplateEdit.vue?vue&type=template&id=6aba825e"
import script from "./emailTemplateEdit.vue?vue&type=script&lang=js"
export * from "./emailTemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./emailTemplateEdit.vue?vue&type=style&index=0&id=6aba825e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports